import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../img/logo.png";
import "../css/navbar.css";

function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [navbarBg, setNavbarBg] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Scroll effect for home page
  useEffect(() => {
    if (!isHome) return;

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBg(true);
      } else {
        setNavbarBg(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  // Navbar classes
  let navClasses = "navbar navbar-expand-lg fixed-top";
  let brandClasses = "navbar-brand d-flex align-items-center";
  let linkTextClass = "";

  if (isHome) {
    if (navbarBg || menuOpen) {
      navClasses += " navbar-light bg-white shadow-sm";
      brandClasses += " text-dark";
      linkTextClass = "text-dark";
    } else {
      navClasses += " navbar-dark bg-transparent";
      brandClasses += " text-white";
      linkTextClass = "text-white";
    }
  } else {
    navClasses += " navbar-dark bg-light shadow-sm";
    brandClasses += " text-dark";
    linkTextClass = "text-dark";
  }

  return (
    <nav className={navClasses}>
      <div className="container">
        {/* Logo */}
        <Link className={brandClasses} to="/">
          <img className="navbar-logo me-2" src={logo} alt="NeatNest Logo" />
          <span className="brand-text">NeatNest</span>
        </Link>

        {/* Toggler */}
       <button
  className="navbar-toggler"
  type="button"
  onClick={() => setMenuOpen(!menuOpen)}
>
  {/* Custom Hamburger Lines */}
  <span className={`toggler-line ${menuOpen ? "open" : ""}`}></span>
  <span className={`toggler-line ${menuOpen ? "open" : ""}`}></span>
  <span className={`toggler-line ${menuOpen ? "open" : ""}`}></span>
</button>


        {/* Menu */}
        <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {["/", "/about", "/services", "/projects", "/contact"].map((path, i) => (
              <li className="nav-item" key={i}>
                <Link
                  className={`nav-link ${linkTextClass}`}
                  to={path}
                  onClick={() => setMenuOpen(false)} // close menu on click
                >
                  {["Home", "About", "Services", "Projects", "Contact"][i]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
